import { useCallback, useMemo, useState } from 'react';
import { TableHeaderCell } from 'common/components';

export const usePerformanceAgentsNameFilter = <T extends { id: string; name: string }>(agents: T[]) => {
    const [selectedAgentIds, setSelectedAgentIds] = useState<string[]>([]);

    const agentOptions = useMemo(
        () =>
            [...agents]
                .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
                .map((agent) => ({ value: agent.id, label: agent.name })),
        [agents]
    );

    const filteredAgents = useMemo(() => {
        if (selectedAgentIds.length === 0) return agents;
        const selectedSet = new Set(selectedAgentIds);
        return agents.filter((agent) => selectedSet.has(agent.id));
    }, [agents, selectedAgentIds]);

    const nameFilterHeader = useCallback(
        () => (
            <TableHeaderCell
                label='Agent'
                isSearchable
                filterOptions={{
                    mode: 'multi',
                    options: agentOptions,
                    selectedValues: selectedAgentIds,
                    onChange: setSelectedAgentIds,
                    allOptionLabel: 'All agents',
                }}
            />
        ),
        [agentOptions, selectedAgentIds]
    );

    return {
        filteredAgents,
        nameFilterHeader,
        selectedAgentIds,
    };
};
